export default "__VITE_ASSET__efe47346__"